import type { ReactElement, CSSProperties } from 'react'

interface CloudProps {
  size?: number
  style?: CSSProperties
}

/**
 * Kumo-mon (Japanese ornamental cloud) decoration. Renders the gold
 * paper-cloud bitmap from `/glyph-assets/kumomon.png` — source
 * `assets/kumomon1.png` processed through `strip-white-bg.mjs`. The
 * intrinsic aspect is ~1.69:1 (858×507 after trim); `size` sets the
 * rendered width and height tracks aspect via `height: auto`.
 *
 * Used as a backdrop / corner-ornament flourish. For symmetric
 * left/right placement, wrap one instance with
 * `style={{ transform: 'scaleX(-1)' }}` so the kara-kumo curl mirrors.
 */
export const Cloud = ({ size = 80, style }: CloudProps): ReactElement => (
  <img
    src="/glyph-assets/kumomon.png"
    alt=""
    width={size}
    style={{
      display: 'block',
      height: 'auto',
      filter: 'drop-shadow(0 3px 0 rgba(42,34,26,0.18))',
      ...style,
    }}
  />
)
